var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadMailersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#16304F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.78 17.159C21.6394 17.0185 21.4488 16.9397 21.25 16.9397C21.0512 16.9397 20.8606 17.0185 20.72 17.159L18.75 19.129V11.75C18.75 11.5511 18.671 11.3603 18.5303 11.2197C18.3897 11.079 18.1989 11 18 11C17.8011 11 17.6103 11.079 17.4697 11.2197C17.329 11.3603 17.25 11.5511 17.25 11.75V19.129L15.28 17.159C15.1378 17.0265 14.9498 16.9544 14.7555 16.9578C14.5612 16.9613 14.3758 17.04 14.2384 17.1774C14.101 17.3148 14.0223 17.5002 14.0188 17.6945C14.0154 17.8888 14.0875 18.0768 14.22 18.219L17.47 21.469L18 22L18.53 21.47L21.78 18.22C21.8497 18.1504 21.905 18.0676 21.9427 17.9766C21.9804 17.8856 21.9998 17.788 21.9998 17.6895C21.9998 17.591 21.9804 17.4934 21.9427 17.4024C21.905 17.3114 21.8497 17.2287 21.78 17.159ZM12.5 19.75C12.5 19.5511 12.421 19.3603 12.2803 19.2197C12.1397 19.079 11.9489 19 11.75 19C11.5511 19 11.3603 19.079 11.2197 19.2197C11.079 19.3603 11 19.5511 11 19.75V23C11 23.5304 11.2107 24.0391 11.5858 24.4142C11.9609 24.7893 12.4696 25 13 25H23C23.5304 25 24.0391 24.7893 24.4142 24.4142C24.7893 24.0391 25 23.5304 25 23V19.75C25 19.5511 24.921 19.3603 24.7803 19.2197C24.6397 19.079 24.4489 19 24.25 19C24.0511 19 23.8603 19.079 23.7197 19.2197C23.579 19.3603 23.5 19.5511 23.5 19.75V23C23.5 23.1326 23.4473 23.2598 23.3536 23.3536C23.2598 23.4473 23.1326 23.5 23 23.5H13C12.8674 23.5 12.7402 23.4473 12.6464 23.3536C12.5527 23.2598 12.5 23.1326 12.5 23V19.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadMailersIcon);
export default __webpack_public_path__ + "static/media/download-mailers-icon.0317c0c94e3f03307e7c744a498ee0ec.svg";
export { ForwardRef as ReactComponent };